/**
 * YTB 子页 401 时通知访问门弹窗
 */
import { isYtbRoutePath } from '@/router/lib/route-prefix.js'
let unauthorizedHandler = null

/** @param {() => void} fn */
export function setYtbUnauthorizedHandler(fn) {
  unauthorizedHandler = fn
}

export function notifyYtbUnauthorized() {
  if (typeof window === 'undefined') return
  if (!isYtbRoutePath(window.location.pathname)) return
  unauthorizedHandler?.()
}

export function isYtbApiUrl(url) {
  const raw = String(url || '')
  if (raw.startsWith('/api/ytb')) return true
  try {
    const u = new URL(raw, window.location.origin)
    return u.pathname.startsWith('/api/ytb')
  } catch {
    return false
  }
}
